import script from "./VideoViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoViewer.vue?vue&type=script&setup=true&lang=ts"

import "./VideoViewer.vue?vue&type=style&index=0&id=bf4fd4e2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf4fd4e2"]])

export default __exports__